import { BaseModalProps, Button, ModalContentWrapper } from 'ui';

interface ReauthenticationRequiredModalProps extends BaseModalProps {
  onProceed: () => void;
}

const ReauthenticationRequiredModal = ({
  open,
  onClose,
  onProceed,
}: ReauthenticationRequiredModalProps) => {
  return (
    <ModalContentWrapper
      title="Re-authentication Required"
      open={open}
      onClose={onClose}
      showClose={false}
    >
      <div className="space-y-4">
        <p className="text-2xl text-gray-600 text-center">
          Please re-authenticate to continue for security purposes. You will be taken to the login
          page.
        </p>
        <Button
          onClick={() => {
            onProceed();
            onClose();
          }}
        >
          Proceed to login
        </Button>
      </div>
    </ModalContentWrapper>
  );
};

export default ReauthenticationRequiredModal;
